module.exports = __webpack_public_path__ + "img/img-95.fc0c3339.png";